import type { ClubPlanTier } from './planFeatures';
import type { SubscriptionBillingCurrency } from './subscriptionPricing';

export type ClubPlanMonthlyPricing = Record<SubscriptionBillingCurrency, number>;

/** Monthly list price for Club plan (tax inclusive via Managed Payments). */
export const CLUB_PLAN_MONTHLY_PRICING: ClubPlanMonthlyPricing = {
  USD: 49,
  AUD: 69,
  GBP: 39,
  EUR: 49,
};

/** Monthly list price for Club Pro plan (tax inclusive via Managed Payments). */
export const CLUB_PRO_PLAN_MONTHLY_PRICING: ClubPlanMonthlyPricing = {
  USD: 89,
  AUD: 129,
  GBP: 79,
  EUR: 89,
};

export const CLUB_PLAN_MONTHLY_PRICING_BY_TIER: Record<ClubPlanTier, ClubPlanMonthlyPricing> = {
  starter: CLUB_PLAN_MONTHLY_PRICING,
  professional: CLUB_PRO_PLAN_MONTHLY_PRICING,
};

export type ClubPlanBillingCurrency = SubscriptionBillingCurrency;
